import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { withRouter } from "react-router";
import NotFound from "../404Page/NotFound";
import Home from "../Home/Home";
import ReadyMadePosts from "../ReadyMadePosts/ReadyMadePosts";
import {
  setWebsiteEmbedding,
  setMultirow,
  setCategoryID,
  setUrlParams,
  setCustomtext,
} from "../../actions";
import { useDispatch } from "react-redux";
import EmailSharerResolver from "../EmailSharerResolver/EmailSharerResolver";

const Routes = (props) => {
  const dispatch = useDispatch();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const catID = urlParams.get("cat_id");
  const websiteEmbedding = urlParams.get("wp");
  const multirow = urlParams.get("multirow");
  const customText = urlParams.get("custom_text") === "false" ? false : true;

  useEffect(() => {
    if (queryString !== "") {
      dispatch(setUrlParams(queryString));
    }

    if (websiteEmbedding === "true") {
      dispatch(setWebsiteEmbedding(true));
      if (multirow === "true") {
        dispatch(setMultirow(true));
      }
    }

    if (catID) {
      dispatch(setCategoryID(catID));
    }

    if (typeof customText === "boolean") {
      dispatch(setCustomtext(customText));
    }
  }, []);

  return (
    <Switch>
      <Route exact path="/campaign/:campaignId" component={Home} />
      <Route
        exact
        path="/campaign/:campaignId/ready_made_post/:platform"
        component={ReadyMadePosts}
      />
      <Route
        exact
        path="/campaign/:campaignId/sharer_resolver"
        component={EmailSharerResolver}
      />
      <Route path="*" component={NotFound} />
    </Switch>
  );
};

export default withRouter(Routes);
